var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"r-scale",class:{ radius: _vm.radius }},_vm._l((_vm.data),function(item,ndx){return _c('div',{key:ndx,staticClass:"scale__status-block",class:{ animation: _vm.animation },style:({
      width: _setup.getPart(item.value),
      backgroundColor: item.backgroundColor,
      height: `${_vm.height}px`
    }),attrs:{"title":_setup.getTitle(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }